module.exports = __webpack_public_path__ + "static/media/iconClassesF.3dd4654c.svg";